import {createFileRoute} from '@tanstack/react-router'

import AssistantScreen from '@protected/assistant'

export const Route = createFileRoute('/_protected/assistant')({component: AssistantScreen})
